<template>
	<div class="container-fluid pb-3" style="padding-top: 80px; min-height: 100vh">
		<dynamic-page slug="about_us" />
	</div>
</template>

<script>
	import DynamicPage from '~/components/dynamic-page'

	export default {
		components: {
			DynamicPage
		},
		head () {
			return {
				title: `${this.merchant.business.name} | ${this.$t('about us')}`
			}
		},
		computed: {
			merchant () {
				return this.$store.state.merchant
			}
		}
	}
</script>

<style lang="css" scoped>
</style>
